import '@modern-js/runtime/registry/main';
import { createRoot } from '@modern-js/runtime/react';
import { render } from '@modern-js/runtime/browser';









const ModernRoot = createRoot();

render(<ModernRoot />, 'root');
